/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Returns a list of ServiceProviderGroups that service Cars on properties
 * managed by the ConsultantGroup of the authenticated user.
 */
export const ServiceProvidersListQueryParams = zod.object({
  "id": zod.string().uuid().optional(),
  "name": zod.string().optional(),
  "name_contains": zod.string().optional(),
  "property_id": zod.string().uuid().optional()
})

export const serviceProvidersListResponseOwnerOneUsernameMax = 150;


export const serviceProvidersListResponseOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const serviceProvidersListResponseOwnerOneEmailMax = 254;

export const serviceProvidersListResponseOwnerOnePhoneNumberMax = 128;



export const ServiceProvidersListResponseItem = zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(serviceProvidersListResponseOwnerOneUsernameMax).regex(serviceProvidersListResponseOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(serviceProvidersListResponseOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(serviceProvidersListResponseOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const ServiceProvidersListResponse = zod.array(ServiceProvidersListResponseItem)

/**
 * Returns a list of ServiceProviderGroups that service Cars on properties
 * managed by the ConsultantGroup of the authenticated user.
 */
export const ServiceProvidersRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this service provider group.')
})

export const serviceProvidersRetrieveResponseOwnerOneUsernameMax = 150;


export const serviceProvidersRetrieveResponseOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const serviceProvidersRetrieveResponseOwnerOneEmailMax = 254;

export const serviceProvidersRetrieveResponseOwnerOnePhoneNumberMax = 128;



export const ServiceProvidersRetrieveResponse = zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(serviceProvidersRetrieveResponseOwnerOneUsernameMax).regex(serviceProvidersRetrieveResponseOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(serviceProvidersRetrieveResponseOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(serviceProvidersRetrieveResponseOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

